import { OUTRO } from '../content';
import { mountChapter } from './chapter';
import type { SceneContext, SceneHandle } from './types';

/**
 * Outro: fleet warp-out + CTA. Same engine as the chapters (canvas sequence
 * on desktop, autoplay-once on mobile) with the CTA link wired on top.
 */
export function mountOutro(ctx: SceneContext): SceneHandle {
  const handle = mountChapter({ ...OUTRO, products: [] }, ctx, {
    pinEnd: '+=140%',
    cinematicPinEnd: '+=80%',
    // Ease-in: the warp-out builds gradually — most of the scroll plays the
    // slow engine-ignition frames, then accelerates through the streak-out.
    progressEase: (p) => p * p,
  });

  const cta = handle.section.querySelector<HTMLAnchorElement>('.outro-cta');
  if (cta) {
    cta.href = OUTRO.cta.href;
    cta.textContent = OUTRO.cta.label;
    cta.rel = 'noopener noreferrer';
    cta.target = '_blank';
  }

  return handle;
}
